/**
 * French labels for the dashboard sidebar navigation tree
 * (see servicesConfigAdvanced.ts). Keyed by node id.
 *
 * Brand names (YouTube, Instagram, Facebook, WhatsApp) stay as-is.
 */
export const SERVICE_LABELS_FR: Record<string, string> = {
  // Automation
  automation: "Automatiser l'entreprise",
  emailAutomation: "Automatisation e-mail",
  emailCampaigns: "Campagnes",
  createCampaign: "Créer une campagne",
  campaignReports: "Rapports",
  emailTemplates: "Modèles",
  createTemplate: "Créer un modèle",
  templateLibrary: "Bibliothèque de modèles",
  whatsappAutomation: "Automatisation WhatsApp",
  broadcast: "Diffusion",
  createBroadcast: "Nouvelle diffusion",
  broadcastLogs: "Journaux",
  autoReply: "Réponse automatique",
  createAutoReply: "Créer une règle",
  replyAnalytics: "Analyses",
  leadAutomation: "Automatisation des prospects",
  leadCapture: "Capture de prospects",
  forms: "Formulaires",
  Leadintegrations: "Intégrations de prospects",
  followUps: "Relances",
  sequence: "Générateur de séquences",
  reminders: "Rappels",

  // Mobile apps
  mobileApps: "Applications mobiles",
  allApps: "Toutes les applications",
  appAnalytics: "Analyses d'applications",

  // Social media growth
  social: "Croissance sur les réseaux sociaux",
  youtube: "YouTube",
  videoOptimization: "Optimisation vidéo",
  tagExtractor: "Extracteur de tags",
  seoSuggestions: "Suggestions SEO",
  analytics: "Analyses",
  views: "Vues et temps de visionnage",
  engagement: "Analyses d'engagement",
  commander: "Centre de commande",
  instagramGrowth: "Instagram",
  contentPlanning: "Planification de contenu",
  calendar: "Calendrier de contenu",
  hashtagResearch: "Recherche de hashtags",
  facebookGrowth: "Facebook",
  homepageFacebook: "Analyses de la page d'accueil",

  // Website
  website: "Développement de sites web",
  allWebsites: "Tous les sites web",
  pages: "Pages",
  createPage: "Créer une page",
  editPage: "Modifier la page",
  seo: "Paramètres SEO",
  metaTags: "Balises méta",
  sitemap: "Plan du site",

  // Tools & utilities
  tools: "Outils et utilitaires",
  emailTools: "E-mail",
  emailValidator: "Validateur d'e-mails",
  bulkEmailValidator: "Validateur d'e-mails en masse",
  smsTools: "SMS",
  smsSender: "Envoyer un SMS",

  // Integrations
  integrations: "Intégrations",
  facebookConnect: "Facebook",
  instagramConnect: "Instagram",
  youtubeConnect: "YouTube",
  whatsappConnect: "WhatsApp Business",
  googleBusiness: "Profil Google Business",
};
